// Quotations Getters

export const getQuotationList = state => {
  return state.quotationList
}

export const getQuotationInfo = state => {
  return state.quotationInfo
}
